// Parti dosya seçici — Geçmiş Rapor Aktarımı (Task 13, eng review 6A).
// `FileDropzone` (Task 12, ortak) üzerine ince bir sarmalayıcı: aktarıma özgü
// accept/limit/red metinlerini bağlar. Yükleme mantığı BURADA DEĞİL — çağıran
// (`NewBatchTab`) gruplayıp `runWithConcurrency(4)` ile yükler (7A).

import { REPORT_IMPORT_MAX_FILE_BYTES } from "@mahir/shared";
import { FileDropzone } from "../common/FileDropzone";
import { IMPORT_COPY, rejectImportFile } from "../../lib/report-import-ui";

const ACCEPT = ".pdf,.docx,application/pdf";

/** `rejectImportFile` kodu → kullanıcı metni (8A/ERROR sütunu). */
function reasonText(file: File): string | null {
  const reason = rejectImportFile(file);
  if (reason === null) return null;
  switch (reason) {
    case "indd":
      return IMPORT_COPY.rejectIndd;
    case "doc":
      return IMPORT_COPY.rejectDoc;
    case "size":
      return IMPORT_COPY.rejectSize;
    case "mime":
      return IMPORT_COPY.dropzoneHint;
  }
}

export interface ImportDropzoneProps {
  onFiles: (files: File[]) => void;
  disabled?: boolean;
  /** Kalan kontenjan (7A — parti başına 100 satır). */
  maxFiles?: number;
}

export function ImportDropzone({
  onFiles,
  disabled = false,
  maxFiles,
}: ImportDropzoneProps): JSX.Element {
  return (
    <div>
      {/* FileDropzone yalnız `label` + `hint` taşır; ana yönerge (IMPORT_COPY.dropzone)
          onun üstünde durur — ortak bileşene aktarıma özgü slot eklenmedi. */}
      <p style={{ margin: "0 0 6px", fontSize: "0.95rem", fontWeight: 600 }}>
        {IMPORT_COPY.dropzone}
      </p>
      <FileDropzone
        accept={ACCEPT}
        multiple
        maxBytes={REPORT_IMPORT_MAX_FILE_BYTES}
        onFiles={onFiles}
        rejectReason={reasonText}
        hint={IMPORT_COPY.dropzoneHint}
        label={IMPORT_COPY.chooseFile}
        disabled={disabled}
        {...(maxFiles !== undefined ? { maxFiles } : {})}
      />
    </div>
  );
}
